<template>
  <div class="pt-3 pb-5 text-white text-center main-hero">
    <div class="container">
        <h1 class="mt-5 pb-3 display-6 fw-bold">Discover benefits with SuperGold</h1>
        <h2 class="mb-3 fw-light fs-4">
          SuperGold helps you stretch your money further with instant discounts and special offers.
        </h2>
        <h2 class="mb-5 fw-light fs-4">
          Explore offers locally or nationwide.
        </h2>

        <ais-search-box>
          <template v-slot="{ currentRefinement, refine }">
            <div class="row g-2">
              <!-- Location Button - Always Full Width -->
              <div class="col-md-4 order-1">
                <button
                  type="button"
                  class="btn bg-white text-primary w-100 mb-2 d-none d-md-block text-truncate"
                  data-bs-toggle="modal"
                  data-bs-target="#mapLocationModal">
                  <i class="bi bi-geo-alt-fill me-2"></i>
                  <span>{{ locationDisplayText }}</span>
                </button>
                <button
                  type="button"
                  class="btn bg-white text-primary w-100 d-block d-md-none"
                  data-bs-toggle="modal"
                  data-bs-target="#mapLocationModal">
                  <i class="bi bi-geo-alt-fill me-2"></i>
                  <span>{{ locationDisplayText }}</span>
                </button>
              </div>

              <!-- Search Input -->
              <div class="col-md-8 order-2 order-md-2">
                <div class="input-group border-0">
                  <div class="input-group-text">
                    <i class="bi bi-search"></i>
                  </div>
                  <input
                    @input="searchQuery = $event.target.value"
                    @keyup.enter="performSearch(refine)"
                    class="form-control border-0 bg-white py-3"
                    type="search"
                    ref="searchInput"
                    placeholder="Search for gardeners, electronics etc"
                    aria-label="Search offers"
                    :value="currentRefinement">
                  <button
                    @click="performSearch(refine)"
                    class="btn bg-white text-primary d-none d-md-block">
                    Search
                  </button>
                </div>
              </div>
            </div>
          </template>
        </ais-search-box>
      </div>
    </div>
</template>

<script>
import { AisSearchBox } from 'vue-instantsearch/vue3/es';
import LocationMixin from '../../mixins/location_mixin.js';

export default {
  name: 'SearchBox',
  components: {
    AisSearchBox,
  },
  mixins: [LocationMixin],
  data() {
    return {
      searchQuery: '',
    };
  },
  computed: {
    locationDisplayText() {
      return this.currentLocationText;
    },
  },
  methods: {
    performSearch(refine) {
      const query = this.searchQuery !== undefined ? this.searchQuery : '';
      refine(query);
    },
  },
};
</script>
